import { defineRule } from 'vee-validate'

const companyNumber = () => {
  defineRule<string, any[]>('company_number', (value, _target, _ctx: any) => {
    if (!value) {
      return true
    }
    return testCompanyRegistrationNumber(value)
  })
}

export default companyNumber
